<kendo-dropdownlist [value]="value" [data]="data" [textField]="textField" [valueField]="valueField"
  (valueChange)="onValueChange($event)">
</kendo-dropdownlist>